<template>
  <div class="list-container">
    <ul v-for="(agents, state) in states" :key="state">
      <li>
        <strong>{{ state }} ( {{ agents.length }} )</strong>
        <ul>
          <li v-for="agent in agents" :key="agent.agentId">
            {{ agent.agentName }}
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'EcsAgentsStatesNames',

  props: {
    states: {
      type: Object,
      default() {
        return [];
      }
    }
  }
};
</script>

<style scoped>
.list-container {
  overflow-y: auto;
  max-height: 260px;
  text-align: left;
  font-size: 16px;
  padding: 20px;
}

.list-container strong {
  font-size: 1.125em;
}
</style>
